import Basic from "../../../../../../packages/design-system/primitives/examples/constellation/text/basic";
import ColorInverse from "../../../../../../packages/design-system/primitives/examples/constellation/text/color-inverse";
import Weight from "../../../../../../packages/design-system/primitives/examples/constellation/text/weight";
import AsElement from "../../../../../../packages/design-system/primitives/examples/constellation/text/as-element";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHtextSLASHbasic from "!!raw-loader!../../../../../../packages/design-system/primitives/examples/constellation/text/basic";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHtextSLASHcolor_inverse from "!!raw-loader!../../../../../../packages/design-system/primitives/examples/constellation/text/color-inverse";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHtextSLASHweight from "!!raw-loader!../../../../../../packages/design-system/primitives/examples/constellation/text/weight";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHtextSLASHas_element from "!!raw-loader!../../../../../../packages/design-system/primitives/examples/constellation/text/as-element";
import * as React from 'react';
export default {
  Basic,
  ColorInverse,
  Weight,
  AsElement,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHtextSLASHbasic,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHtextSLASHcolor_inverse,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHtextSLASHweight,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHtextSLASHas_element,
  React
};